import DeletedCategory from "./DeletedCategory";

export default DeletedCategory;
